<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.provinceName"
              placeholder="请输入省区名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.cityName"
              placeholder="请输入城市名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @del="delFun(arguments)"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 新增 修改-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 新增 修改
import addEditViewDialog from './components/addEditViewDialog'
// API
import { loadSalaryPerformanceBaseInfoListDataApi, exportSalaryPerformanceBaseInfoListDataApi, deleteSalaryPerformanceBaseInfoApi } from '@/api/v2/salaryPerformanceBaseInfo'

export default {
  name: 'SalaryPerformanceBaseInfoView',
  components: {
    CustomTable2,
    TableOperation2,
    addEditViewDialog
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'performance_base_info_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['salary_performance_base_info_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['salary_performance_base_info_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['salary_performance_base_info_del'],
            prop: 'del',
            label: '作废',
            method: 'del'
          },
          {
            permissionSigns: ['salary_performance_base_info_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['salary_performance_base_info_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          provinceName: '',
          cityName: ''
        }
      },
      id: null,
      eventType: '',
      dialogAddEditVisible: false,
      dialogAddEditTitle: '',

    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'province_name', width: 120 },
      { prop: 'cityNames', label: '城市', filterColumn: 'city_names', width: 280 },
      { prop: 'startDate', label: '开始日期', filterColumn: 'start_date', width: 120 },
      { prop: 'endDate', label: '结束日期', filterColumn: 'end_date', width: 120 },
      { prop: 'limitCount', label: '重点信息绩效基础户数', filterColumn: 'limit_count', width: 200 },
      { prop: 'mainAmount', label: '重点绩效单户金额', filterColumn: 'main_amount', width: 160 },
      { prop: 'potentialAmount', label: '潜力绩效单户金额', filterColumn: 'potential_amount', width: 160 },
      { prop: 'infoAmount', label: '信息绩效单户金额', filterColumn: 'info_amount', width: 160 },
      { prop: 'goodDisplayAmount', label: '优秀陈列单户金额', filterColumn: 'good_display_amount', width: 160 },
      { prop: 'noDisplayActivityFieldAmount', label: '无展陈半天场金额(固定)', filterColumn: 'no_display_activity_field_amount', width: 200 },
      { prop: 'displayLessZeroTwoFiveActivityFieldAmount', label: '有展陈半天场金额(固定)小于0.5', filterColumn: 'display_less_zero_two_five_activity_field_amount', width: 240 },
      { prop: 'displayLessOneActivityFieldAmount', label: '有展陈半天场金额(固定)小于1', filterColumn: 'display_less_one_activity_field_amount', width: 240 },
      { prop: 'displayActivityFieldAmount', label: '有展陈半天场金额(固定)大于等于1', filterColumn: 'display_activity_field_amount', width: 240 },
      { prop: 'provisionalNoDisplayActivityFieldAmount', label: '无展陈半天场金额(临时)', filterColumn: 'provisional_no_display_activity_field_amount', width: 200 },
      { prop: 'provisionalDisplayActivityFieldAmount', label: '有展陈半天场金额(临时)', filterColumn: 'provisional_display_activity_field_amount', width: 200 },
      { prop: 'monthActivityAmount', label: '活动包月金额', filterColumn: 'month_activity_amount', width: 160 },
      { prop: 'remark', label: '备注', width: 200 },
      { prop: 'creatorName', filterColumn: 'creator_name', label: '创建人', width: 120 },
      { prop: 'createTime', filterColumn: 'create_time', label: '创建时间', width: 150, isBetween: true },
      { prop: 'operatorName', filterColumn: 'operator_name', label: '操作人', width: 120 },
      { prop: 'operationTime', filterColumn: 'operation_time', label: '操作时间', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadSalaryPerformanceBaseInfoListDataApi(_this.masterList.tableQuery).then(response => {
        const { data } = response;
        this.handleData(data.list || [])
        this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    //新增
    addFun () {
      let _this = this;
      _this.eventType = 'add'
      _this.dialogAddEditTitle = '新增工资绩效基础信息'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 修改
    editFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要修改的工资绩效基础信息', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'edit'
      _this.dialogAddEditTitle = '修改工资绩效基础信息'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 查看
    viewFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的工资绩效基础信息', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'view'
      _this.dialogAddEditTitle = '查看工资绩效基础信息'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 作废
    delFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.$confirm('是否确定作废该工资绩效基础信息？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        deleteSalaryPerformanceBaseInfoApi({ id: args[0].id }).then(() => {
          _this.$message({ message: '作废成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportSalaryPerformanceBaseInfoListDataApi(_this.exportObj).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
